import React from "react";
import { text } from "../constants/tailwind-theme";
import { twMerge } from 'tailwind-merge'


const FooterWithText = () => {

    const [selected, setSelected] = React.useState("DESCRIPTION");
    const [u, setU] = React.useState("underline");
    const [t, setT] = React.useState("");
    return (
        <div className="flex flex-col w-full items-center justify-center bg-tertiary-300">

            <div className=" md:w-6/12 p-4 my-8">

                {/* TOGGLABLE HEADINGS */}
                <div className="flex flex-row">
                    <h1 onClick={() => { setSelected("DESCRIPTION"); setT(""); setU("underline") }} className={twMerge(`${text.heading2} cursor-pointer text-sm mr-5 decoration-3 decoration-primary-500 ${u}`)}>DESCRIPTION</h1>
                    <h1 onClick={() => { setSelected("TERMS"); setU(""); setT("underline") }} className={twMerge(`${text.heading2} cursor-pointer text-sm mr-5 decoration-3 decoration-primary-500 ${t}`)}>TERMS & RULES</h1>
                </div>

                {/*togglable heading content */}
                {selected === "DESCRIPTION" ?
                    <div>
                        <p className={`${text.description1} text-justify mt-8`}>The Afrobeats bazaar is a creative community and marketplace that celebrates music, culture, and art of African descent. It’s a convergence of creative people and entrepreneurs networking to find opportunity in a fun environment immersed in culture and music of African origin.
                            <br />
                            <br />
                            It is our mission to make this a place where people feel a sense of connection and belonging through the experiences we offer.
                            <br />
                            <br />
                            You can help make Afrobeats Happen Participation is at the very core of the Afrobeats Bazaar experience. No matter what you bring to the table — skills, talents, interests, money, resources, a word of encouragement — your gift of participation creates indelible connections, makes the impossible possible. Life is a participatory sport, welcome the team.</p>
                    </div> :
                    <div>
                        
                        <p className={`${text.description1} text-justify mt-3`}>
                            All bookings/ Ticket require QR code details to confirm your reservation.
                            <br />
                            <br />
                            In the event that the booking is not honored or is cancelled with less than 48 hours' notice a cancellation fee of Ghc100 per person will be charged. If this booking is not reconfirmed 7 days prior, we reserve the right to release the table. Tables are available for 6 hours after which they will be re-booked for another customer. Please contact us if you would like to stay at your table for longer than six hours and, if we have space available, we will do our best to accommodate you. For tables booked at 5.30pm or later, your table will not be re-booked. This gives us lead times to run efficient waiting services for better experience.
                            <br />
                            <br />
                            We respectfully ask that you are ready to be seated at the time of your reservation to ensure the best possible level of service to all of our guests. If you are running late, we kindly ask that you notify us by phone at your earliest convenience.
                            Table Allocation
                            Due to the large number of requests, unfortunately we cannot guarantee window tables or specific areas when taking reservations, but we will do our best to accommodate your requests. Your understanding is appreciated.
                            <br />
                            <br />
                            Ticketing Terms and Conditions
                            <br />
                            <br />
                            1 Your ticket(s) are digital tickets that will be delivered in the lead up to the show to your email. You will be instructed to download to your smart device.
                            <br />
                            <br />
                            2 When arriving in groups, the lead booker must be present in order for the whole party to enter the venue . All members of the party should enter the venue at the same time.
                            <br />
                            <br />
                            3 Your ticket purchase constitutes a personal, revocable license and, at all times, remains the property of the promoters.
                            <br />
                            <br />
                            5 Your ticket/s are sold by the promoters directly to you the consumer.  Any tickets purchased by businesses or traders in breach of the terms and conditions of ticket sale will be cancelled. By accepting these terms and conditions you confirm that you are a consumer.
                            <br />
                            <br />
                            6 Your ticket/s will IMMEDIATELY BECOME INVALID if resold OR OFFERED FOR SALE unless the sale is through the official ticket agent fan to fan exchange.  Tickets sold via third parties and other unauthorized outlets, including online auction sites, are not valid for admission. The resale of a ticket renders it invalid and may lead to refusal of entry.
                            <br />
                            <br />
                            7 Ticket sales are limited to a maximum of 6 per transaction.
                            <br />
                            <br />
                            8 Only tickets purchased through approved ticket agents are valid for admission.  The venue reserves the right to refuse admission.
                            <br />
                            <br />
                            9 You will need to use a mobile smartphone to access tickets downloaded to your device.
                        </p>



                    </div>}
            </div>

        </div>
    )
}

export default FooterWithText;